/* Generated from localization/locales.json. Keep localized routes aligned with the backend catalog. */
export const SUPPORTED_LANGUAGE_CODES = [
  'en',
  'fr',
  'de',
  'nl',
  'lb',
  'es',
  'pt',
  'it',
  'el',
  'mt',
  'da',
  'sv',
  'no',
  'fi',
  'is',
  'pl',
  'cs',
  'sk',
  'hu',
  'sl',
  'ro',
  'bg',
  'uk',
  'be',
  'ru',
  'hr',
  'sr',
  'bs',
  'cnr',
  'sq',
  'mk',
  'lt',
  'lv',
  'et',
  'ga',
  'cy',
  'gd',
  'iu',
  'cr',
  'nv',
  'qu',
  'gn',
  'ay',
  'ht',
  'pap',
  'zh',
  'yue',
  'ja',
  'ko',
  'hi',
  'ur',
  'bn',
  'pa',
  'mr',
  'gu',
  'ta',
  'te',
  'kn',
  'ml',
  'or',
  'as',
  'ne',
  'si',
  'id',
  'ms',
  'vi',
  'th',
  'my',
  'km',
  'lo',
  'tl',
  'jv',
  'su',
  'ar',
  'fa',
  'tr',
  'he',
  'ku',
  'uz',
  'kk',
  'az',
  'ps',
  'tk',
  'tg',
  'sw',
  'ha',
  'am',
  'yo',
  'ig',
  'om',
  'so',
  'zu',
  'xh',
  'sn',
  'ln',
  'rw',
] as const;
export type SupportedLanguageCode = (typeof SUPPORTED_LANGUAGE_CODES)[number];
export const LANGUAGE_DIRECTIONS: Record<string, 'ltr' | 'rtl'> = {
  en: 'ltr',
  fr: 'ltr',
  de: 'ltr',
  nl: 'ltr',
  lb: 'ltr',
  es: 'ltr',
  pt: 'ltr',
  it: 'ltr',
  el: 'ltr',
  mt: 'ltr',
  da: 'ltr',
  sv: 'ltr',
  no: 'ltr',
  fi: 'ltr',
  is: 'ltr',
  pl: 'ltr',
  cs: 'ltr',
  sk: 'ltr',
  hu: 'ltr',
  sl: 'ltr',
  ro: 'ltr',
  bg: 'ltr',
  uk: 'ltr',
  be: 'ltr',
  ru: 'ltr',
  hr: 'ltr',
  sr: 'ltr',
  bs: 'ltr',
  cnr: 'ltr',
  sq: 'ltr',
  mk: 'ltr',
  lt: 'ltr',
  lv: 'ltr',
  et: 'ltr',
  ga: 'ltr',
  cy: 'ltr',
  gd: 'ltr',
  iu: 'ltr',
  cr: 'ltr',
  nv: 'ltr',
  qu: 'ltr',
  gn: 'ltr',
  ay: 'ltr',
  ht: 'ltr',
  pap: 'ltr',
  zh: 'ltr',
  yue: 'ltr',
  ja: 'ltr',
  ko: 'ltr',
  hi: 'ltr',
  ur: 'rtl',
  bn: 'ltr',
  pa: 'ltr',
  mr: 'ltr',
  gu: 'ltr',
  ta: 'ltr',
  te: 'ltr',
  kn: 'ltr',
  ml: 'ltr',
  or: 'ltr',
  as: 'ltr',
  ne: 'ltr',
  si: 'ltr',
  id: 'ltr',
  ms: 'ltr',
  vi: 'ltr',
  th: 'ltr',
  my: 'ltr',
  km: 'ltr',
  lo: 'ltr',
  tl: 'ltr',
  jv: 'ltr',
  su: 'ltr',
  ar: 'rtl',
  fa: 'rtl',
  tr: 'ltr',
  he: 'rtl',
  ku: 'ltr',
  uz: 'ltr',
  kk: 'ltr',
  az: 'ltr',
  ps: 'rtl',
  tk: 'ltr',
  tg: 'ltr',
  sw: 'ltr',
  ha: 'ltr',
  am: 'ltr',
  yo: 'ltr',
  ig: 'ltr',
  om: 'ltr',
  so: 'ltr',
  zu: 'ltr',
  xh: 'ltr',
  sn: 'ltr',
  ln: 'ltr',
  rw: 'ltr',
};
